import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { RequisitoMetrica } from '../models/requisito-metrica.model';
import { BaseService } from '../shared/services/base.service';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root'
})
export class RequisitoMetricaService extends BaseService<RequisitoMetrica> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/requisitometrica`, injector);
  }

  getByProjetoId(id: number): Observable<Page<RequisitoMetrica>>  {
    return this.http.get<Page<RequisitoMetrica>>(`${this.apiPath}/GetByProjetoId/${id}`);
  }

  getByRequisitoId(id: number): Observable<Page<RequisitoMetrica>>  {
    return this.http.get<Page<RequisitoMetrica>>(`${this.apiPath}/getByRequisitoId/${id}`);
  }

  getByRequisitoIdMetricaId(requisitoId: number, tipoMmetricaId: number, atividadeMetricaId: number, complexidadeMetricaId: number): Observable<any>  {
    return this.http.get<Page<RequisitoMetrica>>(`${environment.API_PRICE}/requisitometrica/GetByRequisitoIdMetricaId/${requisitoId}/${tipoMmetricaId}/${atividadeMetricaId}/${complexidadeMetricaId}`);
  }

  getTotalHorasByEstimativaId(estimativaId: number): Observable<any> {
    return this.http.get<Page<RequisitoMetrica>>(`${environment.API_PRICE}/requisitometrica/GetTotalHorasByEstimativaId/${estimativaId}`);
  }
}
